import { jsxs as e, jsx as l } from "react/jsx-runtime";
const V = () => /* @__PURE__ */ e(
  "svg",
  {
    width: "101",
    height: "100",
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M100.5 50C100.5 77.6145 78.1145 100 50.5 100C22.8855 100 0.5 77.6145 0.5 50C0.5 22.3855 22.8855 0 50.5 0C78.1145 0 100.5 22.3855 100.5 50Z",
          fill: "#F3F3FD"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M48.3656 50H62.7656V57.2C62.7656 61.178 59.5406 64.4 55.5656 64.4C51.5876 64.4 48.3656 61.178 48.3656 57.2V50Z",
          fill: "#676DFD"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M60.0995 50H74.4995V57.2C74.4995 61.178 71.2745 64.4 67.2995 64.4C63.3215 64.4 60.0995 61.178 60.0995 57.2V50Z",
          fill: "#676DFD"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M40.8995 26H26.4995V33.2C26.4995 37.178 29.7245 40.4 33.6995 40.4C37.6775 40.4 40.8995 37.178 40.8995 33.2V26Z",
          fill: "#676DFD"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M52.6334 26H38.2334V33.2C38.2334 37.178 41.4584 40.4 45.4334 40.4C49.4114 40.4 52.6334 37.178 52.6334 33.2V26Z",
          fill: "#676DFD"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M48.3656 50H74.4996V57.2L74.499 57.289V73.9998H55.146C52.578 73.9998 50.499 71.9208 50.499 69.3528V62.3168C49.1815 61.0122 48.3656 59.2018 48.3656 57.2V50ZM67.2996 64.4C69.343 64.4 71.1882 63.5485 72.499 62.1806V71.9998H65.4984V68.2688C65.4984 67.4588 64.8414 66.7988 64.0284 66.7988H59.7684C58.9554 66.7988 58.2984 67.4588 58.2984 68.2688V71.9998H55.146C53.6826 71.9998 52.499 70.8162 52.499 69.3528V63.7168C53.4293 64.155 54.4687 64.4 55.5656 64.4C57.9849 64.4 60.1265 63.2064 61.4321 61.3752C60.9633 60.7174 60.6024 59.9773 60.3751 59.1807C59.596 61.0705 57.7356 62.4 55.5656 62.4C52.6921 62.4 50.3656 60.0734 50.3656 57.2V52H60.0995L60.0996 57.2C60.0996 61.178 63.3216 64.4 67.2996 64.4ZM62.0996 52H72.4996V57.2C72.4996 60.0729 70.1705 62.4 67.2996 62.4C64.4261 62.4 62.0996 60.0734 62.0996 57.2V52ZM63.4984 71.9988V68.7988H60.2984V71.9988H63.4984Z",
          fill: "#49565D"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M52.6335 26H26.4995V33.2L26.5002 33.2978V49.9997H45.8532C48.4212 49.9997 50.5002 47.9207 50.5002 45.3527V38.3167C51.8176 37.012 52.6335 35.2017 52.6335 33.2V26ZM28.5002 47.9997V38.1807C29.8109 39.5486 31.6561 40.4 33.6995 40.4C36.1207 40.4 38.2619 39.2064 39.5669 37.3752C40.8726 39.2064 43.0141 40.4 45.4335 40.4C46.5304 40.4 47.5699 40.155 48.5002 39.7167V45.3527C48.5002 46.8161 47.3166 47.9997 45.8532 47.9997H42.7008V44.2688C42.7008 43.4588 42.0438 42.7988 41.2308 42.7988H36.9708C36.1578 42.7988 35.5008 43.4588 35.5008 44.2688V47.9997H28.5002ZM38.2335 33.2C38.2335 33.8871 38.3297 34.5516 38.5094 35.1809C37.7309 37.0708 35.8714 38.4 33.6995 38.4C30.8285 38.4 28.4995 36.0729 28.4995 33.2V28H38.2336L38.2335 33.2ZM50.6335 28H40.2335V33.2C40.2335 36.0729 42.5625 38.4 45.4335 38.4C48.3069 38.4 50.6335 36.0734 50.6335 33.2V28ZM37.5008 47.9988V44.7988H40.7008V47.9988H37.5008Z",
          fill: "#49565D"
        }
      ),
      /* @__PURE__ */ l("path", { d: "M56.5001 34.5H66.7521V47H68.7521V32.5H56.5001V34.5Z", fill: "#49565D" }),
      /* @__PURE__ */ l("path", { d: "M34.6995 53V68.5H47.4022V70.5H32.6995V53H34.6995Z", fill: "#49565D" })
    ]
  }
);
export {
  V as ChainIllustration
};
//# sourceMappingURL=index.es483.js.map
